import { createSlice } from '@reduxjs/toolkit';
import { apiCallBegan } from '../../../../store/middleware/apiActions';

const slice = createSlice({
	name: 'people',
	initialState: {
		list: null,
		loading: false,
		lastFetch: null,
		updated: false,
		searchText: '',
	},
	reducers: {
		peopleRequestFailed: (people, action) => {
			people.loading = false;
		},
		peopleRequested: (people, action) => {
			people.loading = true;
		},
		peopleReceived: (people, action) => {
			people.list = action.payload;
			people.loading = false;
			people.lastFetch = Date.now();
			people.updated = false;
		},
		peopleAdded: (people, action) => {
			people.list.push(action.payload);
			people.updated = true;
		},
		peopleDeleted: (people, action) => {
			const index = people.list.findIndex(s => s.id === action.payload.deletedId);
			people.list.splice(index, 1);
			people.updated = true;
		},
		peopleUpdated: (people, action) => {
			// const index = people?.list?.findIndex(s => s.id === action.payload.id);
			// people.list[index] = action.payload;
			// people.updated = true;
		},
		searchTextChanged: (people, action) => {
			people.searchText = action.payload;
		},
		peopleRelated: (people, action) => {
			people.updated = true;
		},
	},
});

export const {
	peopleAdded,
	peopleReceived,
	peopleRequested,
	peopleRequestFailed,
	searchTextChanged,
	peopleUpdated,
	peopleDeleted,
	peopleRelated,
} = slice.actions;

export const loadPeople = () => (dispatch, getState) => {
	// const { lastFetch, list, updated } = getState().entities.people;

	// // var diffMs = Date.now() - lastFetch;
	// // var diffHrs = Math.floor((diffMs % 86400000) / 3600000);

	// // if (diffHrs < 4 && list.length > 0 && !updated) return;

	dispatch(
		apiCallBegan({
			api: 'hammurabi',
			url: '/people',
			onStart: peopleRequested.type,
			onSuccess: peopleReceived.type,
			onError: peopleRequestFailed.type,
		})
	);
};

export default slice.reducer;
